module.exports = __webpack_public_path__ + "img/blue_148.2543920d.png";